import type { Edge, Node } from "@xyflow/react";

import type { Stage } from "../../types.ts";

export interface StageNodeData extends Record<string, unknown> {
	stage: Stage;
	canPromote?: boolean;
	onPromote?: (stageId: string) => void;
}

export type StageNodeType = Node<StageNodeData, "stage">;

const H_GAP = 300;
const V_GAP = 96;

export function buildFlow(stages: Stage[]): {
	nodes: StageNodeType[];
	edges: Edge[];
} {
	const nodes: StageNodeType[] = stages.map((stage, index) => ({
		id: stage.id,
		type: "stage",
		position: { x: stage.depth * H_GAP, y: index * V_GAP },
		data: { stage },
	}));

	const edges: Edge[] = stages
		.filter((stage) => stage.parentId)
		.map((stage) => ({
			id: `${stage.parentId}-${stage.id}`,
			source: stage.parentId as string,
			target: stage.id,
			type: "smoothstep",
		}));

	return { nodes, edges };
}
